import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import './style.css';

export default class Background extends Component {
  render() {
    return (
      <section className="background-animation-canvas">

      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Sections/Background/index.jsx